/* ============================================================
   TERRAIN PDP — Interactive JavaScript
   Coverage Calculator, Seeding Calendar, Variant Selector,
   Sticky ATC, FAQ Accordion, Blend Comparison
   ============================================================ */

(function() {
  'use strict';

  /* ----------------------------------------------------------
     VARIANT SELECTOR
     ---------------------------------------------------------- */
  function initVariantSelector() {
    const pills = document.querySelectorAll('[data-tpdp-variant]');
    const priceEl = document.querySelector('[data-tpdp-price]');
    const priceM2El = document.querySelector('[data-tpdp-price-m2]');
    const variantInput = document.querySelector('[data-tpdp-variant-id]');
    const stickyPrice = document.querySelector('.tpdp-sticky-atc__price');
    const moneyFmt = document.querySelector('[data-tpdp-money-format]');
    const format = moneyFmt ? moneyFmt.dataset.tpdpMoneyFormat : '${{amount}}';

    if (!pills.length) return;

    // Calculate per-m2 price for active pill on load
    var activePill = document.querySelector('.tpdp-hero__variant-pill--active');
    if (activePill && priceM2El) {
      var coverageM2 = activePill.dataset.tpdpVariantCoverage || activePill.dataset.tpdpCoverage;
      var initPrice = activePill.dataset.tpdpVariantPrice;
      if (coverageM2 && parseFloat(coverageM2) > 0 && initPrice) {
        var perM2 = (parseFloat(initPrice) / 100) / parseFloat(coverageM2);
        priceM2El.textContent = perM2.toFixed(2) + ' $/m²';
      }
    }

    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        pills.forEach(function(p) { p.classList.remove('tpdp-hero__variant-pill--active'); });
        pill.classList.add('tpdp-hero__variant-pill--active');

        var vid = pill.dataset.tpdpVariant;
        var price = pill.dataset.tpdpVariantPrice;
        var comparePrice = pill.dataset.tpdpVariantCompare;

        if (variantInput) variantInput.value = vid;

        var formatted = formatMoney(price, format);
        if (priceEl) priceEl.textContent = formatted;
        if (stickyPrice) stickyPrice.textContent = formatted;

        // Update price per m2 if coverage data available
        if (priceM2El) {
          var coverageM2 = pill.dataset.tpdpVariantCoverage || pill.dataset.tpdpCoverage;
          if (coverageM2 && parseFloat(coverageM2) > 0) {
            var pricePerM2 = (parseFloat(price) / 100) / parseFloat(coverageM2);
            priceM2El.textContent = pricePerM2.toFixed(2) + ' $/m²';
          } else {
            priceM2El.textContent = '';
          }
        }

        // Update ATC + sticky button availability state
        var isAvail = pill.dataset.tpdpVariantAvailable === 'true';
        var atcBtn = document.querySelector('[data-tpdp-atc]');
        var stickyBtn = document.querySelector('[data-tpdp-sticky-atc-btn]');
        var notifyEl = document.querySelector('[data-tpdp-notify]');
        if (atcBtn) {
          atcBtn.disabled = !isAvail;
          atcBtn.textContent = isAvail ? 'Ajouter au panier' : 'Rupture de stock';
        }
        if (stickyBtn) {
          stickyBtn.disabled = !isAvail;
          stickyBtn.textContent = isAvail ? 'Ajouter' : 'Rupture de stock';
        }
        if (notifyEl) {
          notifyEl.style.display = isAvail ? 'none' : '';
        }

        // Update URL without reload
        var url = new URL(window.location);
        url.searchParams.set('variant', vid);
        history.replaceState(null, '', url.toString());

        // Dispatch variant:change for fg-store-inventory and other listeners
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: { id: vid, available: isAvail } }
        }));
      });
    });
  }

  /* ----------------------------------------------------------
     COVERAGE CALCULATOR
     ---------------------------------------------------------- */
  function initCoverageCalculator() {
    var calc = document.querySelector('[data-tpdp-calc]');
    if (!calc) return;

    var areaInput = calc.querySelector('[data-tpdp-calc-area]');
    var unitToggles = calc.querySelectorAll('[data-tpdp-calc-unit]');
    var modeToggles = calc.querySelectorAll('[data-tpdp-calc-mode]');
    var resultsEl = calc.querySelector('[data-tpdp-calc-results]');
    var noteEl = calc.querySelector('[data-tpdp-calc-note]');

    var rateNew = parseFloat(calc.dataset.tpdpRateNew) || 2.5;
    var rateOverseed = parseFloat(calc.dataset.tpdpRateOverseed) || 1.5;
    var variants = JSON.parse(calc.dataset.tpdpVariants || '[]');
    var moneyFormat = calc.dataset.tpdpMoneyFormat || '${{amount}}';

    var currentUnit = 'm2';
    var currentMode = 'new';

    // Unit toggles
    unitToggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        unitToggles.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        currentUnit = btn.dataset.tpdpCalcUnit;
        calculate();
      });
    });

    // Mode toggles
    modeToggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        modeToggles.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        currentMode = btn.dataset.tpdpCalcMode;
        calculate();
      });
    });

    // Real-time calculation
    areaInput.addEventListener('input', debounce(calculate, 200));

    function calculate() {
      var rawArea = parseFloat(areaInput.value);
      if (!rawArea || rawArea <= 0) {
        resultsEl.innerHTML = '';
        resultsEl.classList.remove('is-visible');
        return;
      }

      // Convert pi² to m² (1 pi² = 0.0929 m²)
      var areaM2 = currentUnit === 'pi2' ? rawArea * 0.0929 : rawArea;
      var rate = currentMode === 'new' ? rateNew : rateOverseed;
      var kgNeeded = (areaM2 / 100) * rate;

      // Edge case: very large area
      if (areaM2 > 2000) {
        resultsEl.innerHTML = '<div class="tpdp-calc__note">Pour les surfaces de plus de 2 000 m², contactez-nous : <a href="tel:+14502660115">450-266-0115</a></div>';
        resultsEl.classList.add('is-visible');
        return;
      }

      // Build recommendations for each variant (bag size)
      var html = '';
      var bestIdx = findBestVariant(kgNeeded, variants);

      variants.forEach(function(v, i) {
        var bagKg = parseFloat(v.weight_kg);
        var bagsNeeded = Math.ceil(kgNeeded / bagKg);
        var totalPrice = bagsNeeded * parseFloat(v.price);
        var costPerM2 = (totalPrice / 100) / areaM2;
        var isRec = (i === bestIdx);

        var rowClass = 'tpdp-calc__result-row' + (isRec ? ' tpdp-calc__result-row--recommended' : '');
        var recLabel = isRec ? 'data-rec-label="Recommandé"' : '';

        html += '<div class="' + rowClass + '" ' + recLabel + '>'
          + '<span class="tpdp-calc__result-bags">' + bagsNeeded + ' × ' + v.title + '</span>'
          + '<span class="tpdp-calc__result-cpm">' + costPerM2.toFixed(2) + ' $/m²</span>'
          + '<span class="tpdp-calc__result-price">' + formatMoney(Math.round(totalPrice), moneyFormat) + '</span>'
          + '<button type="button" class="tpdp-btn tpdp-btn--primary tpdp-calc__result-atc" '
          + 'data-tpdp-calc-atc data-variant-id="' + v.id + '" data-quantity="' + bagsNeeded + '">'
          + 'Ajouter</button>'
          + '</div>';
      });

      resultsEl.innerHTML = html;
      resultsEl.classList.add('is-visible');

      // Attach ATC handlers
      resultsEl.querySelectorAll('[data-tpdp-calc-atc]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          addToCart(btn.dataset.variantId, parseInt(btn.dataset.quantity), btn);
        });
      });
    }

    function findBestVariant(kgNeeded, variants) {
      // Find the variant that minimizes waste while covering the need
      var bestIdx = 0;
      var bestWaste = Infinity;

      variants.forEach(function(v, i) {
        var bagKg = parseFloat(v.weight_kg);
        var bags = Math.ceil(kgNeeded / bagKg);
        var totalKg = bags * bagKg;
        var waste = totalKg - kgNeeded;
        var totalCost = bags * parseFloat(v.price);

        // Prefer less waste, but also prefer fewer bags (25kg over 17x 1.5kg)
        var score = waste + (bags * 0.5);
        if (score < bestWaste) {
          bestWaste = score;
          bestIdx = i;
        }
      });

      return bestIdx;
    }
  }

  /* ----------------------------------------------------------
     SEEDING CALENDAR
     ---------------------------------------------------------- */
  function initSeedingCalendar() {
    var calendarEl = document.querySelector('[data-tpdp-calendar]');
    if (!calendarEl) return;

    var months = calendarEl.querySelectorAll('[data-tpdp-month]');
    var now = new Date();
    var currentMonth = now.getMonth(); // 0-indexed

    var currentStatus = null;
    months.forEach(function(m) {
      var monthIdx = parseInt(m.dataset.tpdpMonth);
      if (monthIdx === currentMonth) {
        m.classList.add('tpdp-calendar__month--current');
        m.dataset.marker = 'Vous êtes ici';
        currentStatus = m.dataset.tpdpMonthStatus;
        // Scroll the strip horizontally to center the current month (without moving the page)
        setTimeout(function() {
          var strip = m.closest('.tpdp-calendar__strip');
          if (strip) {
            var stripRect = strip.getBoundingClientRect();
            var monthRect = m.getBoundingClientRect();
            var offset = monthRect.left - stripRect.left + strip.scrollLeft - (stripRect.width / 2) + (monthRect.width / 2);
            strip.scrollTo({ left: offset, behavior: 'smooth' });
          }
        }, 300);
      }
    });

    // Activate contextual banner based on current month status
    if (currentStatus) {
      var banner = calendarEl.querySelector('[data-tpdp-banner="' + currentStatus + '"]');
      if (banner) banner.removeAttribute('hidden');
    }

    // Calendar scroll hint — hide on first user scroll
    var strip = calendarEl.querySelector('.tpdp-calendar__strip');
    if (strip) {
      strip.addEventListener('scroll', function() {
        strip.classList.add('is-scrolled');
      }, { once: true });
    }
  }

  /* ----------------------------------------------------------
     FAQ ACCORDION — one open at a time
     ---------------------------------------------------------- */
  function initFaqAccordion() {
    var faqs = document.querySelectorAll('.tpdp-faq__item');
    faqs.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (item.open) {
          faqs.forEach(function(other) {
            if (other !== item && other.open) other.open = false;
          });
        }
      });
    });

    // Language toggle
    var langBtns = document.querySelectorAll('[data-tpdp-faq-lang]');
    langBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        langBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var lang = btn.dataset.tpdpFaqLang;

        document.querySelectorAll('[data-tpdp-faq-fr]').forEach(function(el) {
          el.style.display = lang === 'fr' ? '' : 'none';
        });
        document.querySelectorAll('[data-tpdp-faq-en]').forEach(function(el) {
          el.style.display = lang === 'en' ? '' : 'none';
        });
      });
    });
  }

  /* ----------------------------------------------------------
     QUANTITY SELECTOR
     ---------------------------------------------------------- */
  function initQuantitySelector() {
    var wrap = document.querySelector('[data-tpdp-qty]');
    if (!wrap) return;

    var input = document.querySelector('[data-tpdp-qty-input]');
    var count = wrap.querySelector('[data-tpdp-qty-count]');
    var minus = wrap.querySelector('[data-tpdp-qty-minus]');
    var plus = wrap.querySelector('[data-tpdp-qty-plus]');
    if (!input || !count || !minus || !plus) return;

    function update(val) {
      val = Math.max(1, Math.min(99, val));
      input.value = val;
      count.textContent = val;
      minus.disabled = (val <= 1);
    }

    minus.addEventListener('click', function() { update(parseInt(input.value) - 1); });
    plus.addEventListener('click', function() { update(parseInt(input.value) + 1); });
    update(1);
  }

  /* ----------------------------------------------------------
     STICKY ATC — show on scroll past hero (desktop + mobile)
     ---------------------------------------------------------- */
  function initStickyATC() {
    var sticky = document.querySelector('.tpdp-sticky-atc');
    var heroSection = document.querySelector('.tpdp-hero');
    if (!sticky || !heroSection) return;

    // Move to body to escape section stacking context (z-index: 1)
    document.body.appendChild(sticky);

    // Dynamically track header height for desktop positioning
    var headerEl = document.querySelector('.shopify-section-header');
    function updateStickyOffset() {
      if (window.innerWidth > 768 && headerEl) {
        var headerH = headerEl.getBoundingClientRect().height;
        sticky.style.setProperty('--tpdp-sticky-offset', headerH + 'px');
      } else {
        sticky.style.setProperty('--tpdp-sticky-offset', '0px');
      }
    }
    updateStickyOffset();

    // Show sticky only after hero section has fully scrolled out of view.
    // rootMargin: negative bottom margin ensures the hero must be fully
    // above the viewport (plus a small buffer) before the bar appears.
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        } else {
          // Only show if hero is ABOVE viewport (user scrolled down past it)
          if (entry.boundingClientRect.bottom < 0) {
            sticky.classList.add('is-visible');
            sticky.setAttribute('aria-hidden', 'false');
            updateStickyOffset();
          }
        }
      });
    }, { threshold: 0 });

    observer.observe(heroSection);

    // ATC button in sticky bar
    var stickyBtn = sticky.querySelector('[data-tpdp-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var vid = document.querySelector('[data-tpdp-variant-id]');
        var qty = document.querySelector('[data-tpdp-qty-input]');
        var quantity = qty ? parseInt(qty.value) || 1 : 1;
        if (vid) addToCart(vid.value, quantity, stickyBtn);
      });
    }
  }

  /* ----------------------------------------------------------
     CART API — canonical FGE Ajax-cart pattern
     (mirrors sentinel-pdp.js and moulee-product-hero.liquid)

     The drawer has to be re-rendered from the server, not merely
     toggled: fetch the current page with
     ?sections=cart-drawer,cart-icon-bubble to get freshly
     server-rendered HTML, then hand it to cartDrawer.renderContents(),
     which swaps the DOM and opens the drawer in one step. Clicking the
     header bubble on its own only opens stale markup that does not show
     the item just added.
     ---------------------------------------------------------- */
  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      var cartLink = document.getElementById('cart-icon-bubble');
      if (cartLink) cartLink.click();
      return Promise.resolve();
    }
    /* A drawer rendered while the cart was empty carries .is-empty,
       which keeps it collapsed even once it has contents. */
    if (cartDrawer.classList.contains('is-empty')) {
      cartDrawer.classList.remove('is-empty');
    }
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', {
      credentials: 'same-origin'
    })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        cartDrawer.renderContents({ sections: sections });
      })
      .catch(function(err) {
        console.error('TERRAIN PDP: drawer render failed', err);
        var cartLink = document.getElementById('cart-icon-bubble');
        if (cartLink) cartLink.click();
      });
  }

  function addToCart(variantId, quantity, triggerBtn) {
    var id = String(parseInt(variantId, 10));
    if (!id || id === 'NaN') return;
    var qty = parseInt(quantity, 10) || 1;

    // Loading state on the trigger button
    var origText = '';
    if (triggerBtn) {
      origText = triggerBtn.textContent;
      triggerBtn.dataset.origText = origText;
      triggerBtn.disabled = true;
      triggerBtn.textContent = 'Ajout en cours…';
    }

    var controller = new AbortController();
    var timeout = setTimeout(function() { controller.abort(); }, 8000);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: 'id=' + encodeURIComponent(id) + '&quantity=' + encodeURIComponent(qty),
      signal: controller.signal
    })
    .then(function(res) {
      clearTimeout(timeout);
      if (!res.ok) {
        return res.json().then(function(err) {
          throw new Error((err && err.description) ? err.description : 'Cart error ' + res.status);
        });
      }
      return res.json();
    })
    .then(function() {
      /* Render the drawer FIRST, then dispatch the refresh events, so any
         listener that writes into the drawer is not wiped by renderContents
         replacing innerHTML. The cart-icon-bubble count comes back
         server-rendered in the same response, so there is no manual
         increment to drift out of sync with the real cart. */
      return Promise.resolve(openCartDrawer()).then(function() {
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        try { window.dispatchEvent(new Event('cart:refresh')); } catch (e) {}
      });
    })
    .then(function() {
      if (triggerBtn) {
        triggerBtn.textContent = 'Ajouté ✓';
        triggerBtn.classList.add('is-added');
        setTimeout(function() {
          triggerBtn.textContent = triggerBtn.dataset.origText || origText;
          triggerBtn.classList.remove('is-added');
          triggerBtn.disabled = false;
        }, 2000);
      }
    })
    .catch(function(err) {
      clearTimeout(timeout);
      console.error('TERRAIN PDP: Cart add failed', err);
      if (triggerBtn) {
        triggerBtn.disabled = false;
        triggerBtn.textContent = 'Erreur, réessayez';
        setTimeout(function() {
          triggerBtn.textContent = triggerBtn.dataset.origText || origText;
        }, 2500);
      }
    });
  }

  /* ----------------------------------------------------------
     BLEND COMPARISON — mobile expand
     ---------------------------------------------------------- */
  function initBlendComparison() {
    var rows = document.querySelectorAll('.tpdp-compare-table tbody tr');
    if (window.innerWidth > 768) return;

    rows.forEach(function(row) {
      row.addEventListener('click', function() {
        var isExpanded = row.classList.contains('is-expanded');
        rows.forEach(function(r) { r.classList.remove('is-expanded'); });
        if (!isExpanded) row.classList.add('is-expanded');
      });
    });
  }

  /* ----------------------------------------------------------
     IMAGE GALLERY — thumbnail click + active state
     ---------------------------------------------------------- */
  function initImageGallery() {
    var thumbs = document.querySelectorAll('[data-tpdp-thumb-index]');
    var medias = document.querySelectorAll('[data-tpdp-media-index]');
    if (!thumbs.length || !medias.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = thumb.dataset.tpdpThumbIndex;

        thumbs.forEach(function(t) { t.classList.remove('tpdp-hero__thumb--active'); });
        thumb.classList.add('tpdp-hero__thumb--active');

        medias.forEach(function(m) {
          m.classList.toggle('tpdp-hero__media--active', m.dataset.tpdpMediaIndex === idx);
        });
      });
    });
  }

  /* ----------------------------------------------------------
     HERO FORM INTERCEPT — use AJAX instead of form POST
     ---------------------------------------------------------- */
  function initHeroFormIntercept() {
    var form = document.querySelector('[data-tpdp-form]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var vid = form.querySelector('[data-tpdp-variant-id]');
      var qty = form.querySelector('[data-tpdp-qty-input]');
      var btn = form.querySelector('[data-tpdp-atc]');
      if (vid && !btn.disabled) {
        addToCart(vid.value, parseInt(qty ? qty.value : 1), btn);
      }
    });
  }

  /* ----------------------------------------------------------
     HELPERS
     ---------------------------------------------------------- */
  function formatMoney(cents, format) {
    var amount = (parseInt(cents) / 100).toFixed(2);
    var amountNoDecimals = Math.round(parseInt(cents) / 100);
    return format
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals);
  }

  function debounce(fn, delay) {
    var timer;
    return function() {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(ctx, args); }, delay);
    };
  }

  /* ----------------------------------------------------------
     SCROLL REVEAL — IntersectionObserver fade-up
     Adds .tpdp-reveal to sections, reveals on scroll
     ---------------------------------------------------------- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    // Add reveal class to all major sections (skip hero — already visible)
    var sections = document.querySelectorAll(
      '.tpdp-section:not(.tpdp-hero), .tpdp-compare, .tpdp-cross-sell, .tpdp-brand-footer, .tpdp-semer'
    );
    sections.forEach(function(el) {
      if (!el.classList.contains('tpdp-reveal')) {
        el.classList.add('tpdp-reveal');
      }
    });

    // Also add stagger to grids
    var grids = document.querySelectorAll(
      '.tpdp-identity__grid, .tpdp-cross-sell__grid, .tpdp-hero__badges'
    );
    grids.forEach(function(el) {
      el.classList.add('tpdp-reveal-stagger');
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.classList.add('trn-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.tpdp-reveal, .tpdp-reveal-stagger, .trn-reveal, .trn-reveal-stagger').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ----------------------------------------------------------
     JUMP LINKS — smooth scroll to anchor sections
     ---------------------------------------------------------- */
  function initJumpLinks() {
    document.querySelectorAll('.tpdp-hero__jump-link, [data-trn-scroll]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href) || document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          var headerOffset = 140;
          var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });
  }

  /* ----------------------------------------------------------
     NOTIFY FORM — email capture for out-of-stock
     ---------------------------------------------------------- */
  function initNotifyForm() {
    var form = document.querySelector('[data-tpdp-notify-form]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('.tpdp-hero__notify-input');
      if (!email || !email.value) return;

      var btn = form.querySelector('.tpdp-hero__notify-btn');
      if (btn) {
        btn.textContent = 'Merci!';
        btn.disabled = true;
        email.disabled = true;
      }
      // In production, POST to Klaviyo or back-in-stock app endpoint
      console.log('[TERRAIN PDP] Notify request:', email.value, 'for variant:', document.querySelector('[data-tpdp-variant-id]')?.value);
    });
  }

  /* ----------------------------------------------------------
     INIT ON DOM READY
     ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var fns = [
      initVariantSelector,
      initImageGallery,
      initQuantitySelector,
      initCoverageCalculator,
      initSeedingCalendar,
      initFaqAccordion,
      initStickyATC,
      initBlendComparison,
      initScrollReveal,
      initHeroFormIntercept,
      initJumpLinks,
      initNotifyForm
    ];
    fns.forEach(function(fn) {
      try { fn(); } catch(e) { console.warn('[TERRAIN PDP]', fn.name, e.message); }
    });
  }
})();
